import React from "react";

import "../App.css";
const Shimmer = () => {
  return (
    <div className="flex flex-wrap justify-center p-4 bg-black">
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
      <div className="blink"></div>
    </div>
  );
};

export default Shimmer;
